module.exports = __webpack_public_path__ + "img/course_img2.261359e6.jpg";